import { type Enum } from "@/types";

export const logLevel = {
  DEBUG: "debug",
  INFO: "info",
  LOG: "log",
  WARN: "warn",
  ERROR: "error",
} as const;
export type LogLevel = Enum<typeof logLevel>;

export const DefaultLogLevel = logLevel.INFO;
export type Logger = (level: LogLevel, message: string, context?: Record<string, unknown>, ...rest: unknown[]) => void;

export const logLevelPriority: string[] = Object.values(logLevel);

export const isLogLevel = (level: string | undefined): level is LogLevel => {
  if (level === undefined) {
    return false;
  }

  return logLevelPriority.includes(level);
};

/**
 * Type safe narrowing function to check if an error is an instance of an error
 * or if it has the same standard properties as a base error
 */
export const isError = (error: unknown): error is Error => {
  if (error instanceof Error) {
    return true;
  }

  if (typeof error === "object") {
    return error !== null && "name" in error && "message" in error && "stack" in error;
  }

  return false;
};
